import { useState, useCallback } from 'react';
import { message } from 'antd';
import { c505Api } from '../../../services/c505Api';
import type { ItemState } from './useC505Query';

export function useC505Approval(
  items: ItemState[],
  resetItems: () => void
) {
  const [executing, setExecuting] = useState(false);

  /** Execute approval for all selected items */
  const handleExecute = useCallback(async (): Promise<boolean> => {
    const selectedNos = items
      .filter((s) => s.selected)
      .map((s) => s.item.fc130_01);

    if (selectedNos.length === 0) {
      message.warning('請先勾選要核准的銷貨退回單');
      return false;
    }

    setExecuting(true);
    try {
      const res = await c505Api.execute(selectedNos);
      if (res.failed === 0) {
        message.success(res.message || `核准完成，成功 ${res.success} 筆`);
      } else {
        message.warning(
          res.message || `成功 ${res.success} 筆，失敗 ${res.failed} 筆`
        );
        if (res.results) {
          res.results
            .filter((r) => !r.success)
            .forEach((r) => message.error(`${r.return_no}: ${r.message}`));
        }
      }
      // Clear items after execution
      resetItems();
      return true;
    } catch (e: unknown) {
      const err = e as { response?: { data?: { error?: string } } };
      message.error(err.response?.data?.error || '核准執行失敗');
      return false;
    } finally {
      setExecuting(false);
    }
  }, [items, resetItems]);

  return {
    executing,
    handleExecute,
  };
}
